import { render, staticRenderFns } from "./ItemDropList.vue?vue&type=template&id=4c8d6782&scoped=true&"
import script from "./ItemDropList.vue?vue&type=script&lang=ts&"
export * from "./ItemDropList.vue?vue&type=script&lang=ts&"
import style0 from "./ItemDropList.vue?vue&type=style&index=0&id=4c8d6782&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8d6782",
  null
  
)

export default component.exports